import { FC, MouseEventHandler } from 'react'

import './style.scss'

type ModalProps = {
  show: boolean,
  maxWidth?: string,
  iframe?:boolean,
  buttonCloseHide?:boolean,
  onClose?: MouseEventHandler<HTMLButtonElement>,
}

const Modal:FC<ModalProps> = ({ children, show = false, maxWidth, iframe, buttonCloseHide = false, onClose })  => {
  return (
    <div className={`modal-overlay ${show ? 'modal-overlay--active' : ''} ${iframe ? 'modal--iframe' : ''}`}>
      <div className={`modal ${show ? 'modal--active' : ''}`} style={{ maxWidth: maxWidth }}>
        {!buttonCloseHide && <button className="modal_btn-close" onClick={onClose}>×</button>}
        {children}
      </div>
    </div>
  )
}

export { Modal }